import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcOperations = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M21.526 15.134a.75.75 0 0 1 .406.98 10.703 10.703 0 0 1-3.389 4.413c-4.71 3.614-11.458 2.726-15.072-1.984a.75.75 0 0 1 1.19-.913 9.25 9.25 0 0 0 12.97 1.707 9.204 9.204 0 0 0 2.915-3.796.75.75 0 0 1 .98-.407Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M1.612 15.407a.5.5 0 0 1 .66-.506L5.506 16a.5.5 0 0 1 .143.87l-3.005 2.307a.5.5 0 0 1-.804-.363l-.227-3.408ZM6.368 4.66a9.25 9.25 0 0 1 12.97 1.708l-.988.757a.5.5 0 0 0 .143.87l3.233 1.101a.5.5 0 0 0 .66-.506l-.227-3.407a.5.5 0 0 0-.803-.364l-.828.635C16.914.744 10.165-.144 5.455 3.47a10.704 10.704 0 0 0-3.39 4.416.75.75 0 0 0 1.387.572A9.204 9.204 0 0 1 6.368 4.66Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.577 6a.5.5 0 0 1 .493.418l.067.4a.533.533 0 0 0 .372.413 4.995 4.995 0 0 1 1.866 1.08.533.533 0 0 0 .544.114l.381-.142a.5.5 0 0 1 .608.218l.577.998a.5.5 0 0 1-.115.636l-.313.258a.533.533 0 0 0-.173.528 5.018 5.018 0 0 1 0 2.158.533.533 0 0 0 .173.528l.313.258a.5.5 0 0 1 .115.636l-.576.998a.5.5 0 0 1-.609.218l-.38-.142a.533.533 0 0 0-.545.114 4.994 4.994 0 0 1-1.866 1.08.533.533 0 0 0-.372.414l-.067.4a.5.5 0 0 1-.493.417h-1.153a.5.5 0 0 1-.493-.418l-.067-.4a.533.533 0 0 0-.371-.413 4.994 4.994 0 0 1-1.867-1.08.533.533 0 0 0-.544-.114l-.38.142a.5.5 0 0 1-.61-.218l-.576-.998a.5.5 0 0 1 .115-.636l.313-.258a.533.533 0 0 0 .173-.528 5.018 5.018 0 0 1 0-2.158.533.533 0 0 0-.173-.528l-.313-.258a.5.5 0 0 1-.115-.636l.577-.998a.5.5 0 0 1 .608-.218l.38.142c.188.07.397.02.545-.114a4.995 4.995 0 0 1 1.867-1.08.533.533 0 0 0 .371-.414l.067-.4A.5.5 0 0 1 11.424 6h1.153Zm-.576 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcOperations");

export { IcOperations };
//# sourceMappingURL=ic-operations.js.map
